import { httpService } from "@/common/services/HttpService";
import { AdminStore } from "@/common/models/AdminStore";
import { StaffStore } from "@/common/models/StaffStore";
import { CreateAdminStoreData } from "@/stores/pages/models/CreateAdminStoreData";
import { AdminReceipt, AdminReceiptListItem } from "@/common/models/Receipt";
import { PaginatedResponse } from "@/common/models/PaginatedResponse";

class StoreService {
  stores: StaffStore[] = [];
  selectedStore = "";

  async getAdminStoreById(storeId: string): Promise<AdminStore | null> {
    const { data } = await httpService.getInstance().get<AdminStore>(`/api/v1/backoffice/admin/stores/${storeId}`);
    return data;
  }

  getStoreTimeZone(storeId: string): string | null {
    return this.stores.find((store: StaffStore) => store.id === storeId)?.timeZone ?? null;
  }

  async getStoresStaff(): Promise<StaffStore[]> {
    const { data } = await httpService.getInstance().get<StaffStore[]>("/api/v1/backoffice/staff/stores");
    this.selectedStore = data[0]?.id;
    return data;
  }

  async createStore(store: CreateAdminStoreData): Promise<AdminStore> {
    const { data } = await httpService.getInstance().post<AdminStore>("/api/v1/backoffice/admin/stores", store);
    return data;
  }

  async updateStore(store: AdminStore): Promise<AdminStore> {
    const { data } = await httpService.getInstance().put<AdminStore>("/api/v1/backoffice/admin/stores", store);
    return data;
  }

  async initializeStoreProducts(store: AdminStore): Promise<void> {
    await httpService.getInstance().post<void>(`/api/v1/backoffice/admin/products/stores/${store.id}/initialize`);
  }

  async collectStores(): Promise<void> {
    const staffStorePromise = this.getStoresStaff();
    this.stores = await staffStorePromise;
  }

  async getReceipts(
    storeId: string,
    userId: string | undefined | null,
    from: string | undefined | null,
    to: string | undefined | null,
    offset: number,
    limit: number
  ): Promise<PaginatedResponse<AdminReceiptListItem>> {
    const { data } = await httpService.getInstance().get(`/api/v1/backoffice/staff/stores/${storeId}/receipts`, {
      params: {
        userId,
        from,
        to,
        offset,
        limit,
      },
    });
    return data;
  }

  async getReceipt(storeId: string, receiptId: string): Promise<AdminReceipt> {
    const { data } = await httpService
      .getInstance()
      .get(`/api/v1/backoffice/staff/stores/${storeId}/receipts/${receiptId}`);
    return data;
  }
}

export const storeService = new StoreService();
